
(function(){
  "use strict";
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (!reduceMotion) document.documentElement.classList.add("js");

  
  var header = document.getElementById("siteHeader");
  var lastY = -1;
  function onScroll(){
    var y = window.scrollY;
    if ((y > 24) !== (lastY > 24)) header.classList.toggle("scrolled", y > 24);
    lastY = y;
  }
  window.addEventListener("scroll", onScroll, {passive:true});
  onScroll();

  
  var revealables = document.querySelectorAll(".rv:not(.in)");
  var t0 = performance.now();
  if (!reduceMotion && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) {
          
          if (performance.now() - t0 < 600) e.target.classList.add("now");
          e.target.classList.add("in"); io.unobserve(e.target);
        }
      });
    }, {threshold:.14, rootMargin:"0px 0px -6% 0px"});
    revealables.forEach(function(el){ io.observe(el); });
  } else {
    revealables.forEach(function(el){ el.classList.add("in"); });
  }

  
  var mbar = document.querySelector(".mbar");
  var heroSec = document.querySelector(".page-hero");
  if (mbar && heroSec && "IntersectionObserver" in window) {
    var bio = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        mbar.classList.toggle("tucked", e.isIntersecting);
        header.classList.toggle("past-hero", !e.isIntersecting); 
      });
    }, {threshold:.25});
    bio.observe(heroSec);
  }

  
  var navToggle = document.getElementById("navToggle");
  var mobileMenu = document.getElementById("mobileMenu");
  if (navToggle && mobileMenu) {
    navToggle.addEventListener("click", function(){
      var open = mobileMenu.classList.toggle("open");
      navToggle.setAttribute("aria-expanded", open ? "true" : "false");
      navToggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
      document.body.classList.toggle("menu-open", open);
      if (open) header.classList.add("scrolled"); 
      else onScroll();
    });
    document.addEventListener("keydown", function(e){
      if (e.key === "Escape" && mobileMenu.classList.contains("open")) navToggle.click();
    });
  }

  
  var drop = document.getElementById("navDrop");
  var dropBtn = drop ? drop.querySelector(".nav-drop-btn") : null;
  function closeDrop(){ drop.classList.remove("open"); dropBtn.setAttribute("aria-expanded","false"); }
  if (drop && dropBtn) {
    dropBtn.addEventListener("click", function(e){
      e.stopPropagation();
      var open = drop.classList.toggle("open");
      dropBtn.setAttribute("aria-expanded", open ? "true" : "false");
    });
    document.addEventListener("click", function(e){
      if (drop.classList.contains("open") && !drop.contains(e.target)) closeDrop();
    });
    document.addEventListener("keydown", function(e){
      if (e.key === "Escape" && drop.classList.contains("open")) { closeDrop(); dropBtn.focus(); }
    });
  }

  
  
  var acuCards = document.querySelectorAll(".acuity-card[data-acuity]");
  var acuReady = [];
  window.addEventListener("message", function(e){ 
    if (/acuityscheduling\.com$/.test(e.origin)) acuReady.forEach(function(fn){ fn(); });
  });
  Array.prototype.forEach.call(acuCards, function(card){
    var fr = card.querySelector("iframe");
    if (!fr) return;
    var done = false;
    
    function loaded(){ card.classList.add("loaded"); }
    function ready(){ done = true; card.classList.add("ready"); card.classList.remove("failed"); }
    acuReady.push(ready);
    fr.addEventListener("load", loaded);
    if (fr.dataset.loaded === "1") loaded();
    if (window.__acuityReady) ready(); 
    
    var timer = null;
    function arm(){ if (done || timer) return; timer = setTimeout(function(){ if (!done) card.classList.add("failed"); }, 15000); }
    if ("IntersectionObserver" in window) {
      var aio = new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if (e.isIntersecting) { arm(); aio.disconnect(); } });
      }, {threshold:0});
      aio.observe(card);
    } else arm();
  });

  
  
  function wireSchoolFinder(inputId, listId, wrapId, otherId, prefix){
    var inp = document.getElementById(inputId), list = document.getElementById(listId);
    var wrap = document.getElementById(wrapId), other = document.getElementById(otherId);
    if (!inp || !list || !wrap || !other || !window.PATEKA || !window.PATEKA.attachFinder) return;
    function showOther(on){ wrap.hidden = !on; other.required = on; if (on) other.focus(); else other.value = ""; }
    window.PATEKA.attachFinder(inp, list, {
      idPrefix: prefix, otherLabel: "My school isn't listed", otherValue: "Other school",
      onPick: function(){ showOther(false); },
      onOther: function(){ showOther(true); },
      onInput: function(){ if (inp.value !== "Other school") showOther(false); }
    });
  }
  wireSchoolFinder("ftSchool", "ftSchoolMatches", "ftOtherWrap", "ftOther", "ftSchoolOpt-");
  wireSchoolFinder("siSchool", "siSchoolMatches", "siOtherWrap", "siOther", "siSchoolOpt-");

  
  Array.prototype.forEach.call(document.querySelectorAll('input[name="_next"]'), function(i){ i.value = location.origin + "/thank-you" + (i.form && i.form.classList.contains("foot-signup") ? "?signup=1" : ""); });

  
  var FORM_ENDPOINT = "https://formsubmit.co/ajax/info@patekasocceracademy.com.au";
  var pForms = document.querySelectorAll("form[data-pateka-form]");
  Array.prototype.forEach.call(pForms, function(f){
    f.addEventListener("submit", function(e){
      e.preventDefault();
      var status = f.querySelector(".f-status");
      var btn = f.querySelector('button[type="submit"]');
      
      var hp = f.querySelector('input[name="_honey"]'); if (hp) hp.value = "";
      var data = new FormData(f);
      if (btn) btn.disabled = true;
      if (status){ status.textContent = "Sending…"; status.className = "f-status"; }
      var settled = false;
      function native(){ 
        if (settled) return; settled = true;
        HTMLFormElement.prototype.submit.call(f);
      }
      var slow = setTimeout(native, 12000);
      fetch(FORM_ENDPOINT, { method:"POST", body:data, headers:{ "Accept":"application/json" } })
        .then(function(r){ if(!r.ok) throw new Error("http " + r.status); return r.json(); })
        .then(function(res){
          if (settled) return;
          if (res && String(res.success) === "false") throw new Error(res.message || "send failed");
          settled = true; clearTimeout(slow);
          window.location.assign("/thank-you" + (f.classList.contains("foot-signup") ? "?signup=1" : ""));
        })
        .catch(function(err){
          if (settled) return;
          clearTimeout(slow);
          if (err instanceof TypeError) { native(); return; } 
          settled = true;
          if (btn) btn.disabled = false;
          if (status){
            status.textContent = "That didn't send. Please try again, or call 0418 791 706.";
            status.className = "f-status err";
          }
        });
    });
  });
})();
